/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsControllerFindSimilarQueryResponse,
  TelegramProductsControllerFindSimilarPathParams,
  TelegramProductsControllerFindSimilar401,
} from '../../types/TelegramProductsControllerFindSimilar.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramProductsFindSimilar } from '../../methods/telegramProductsFindSimilar.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramProductsFindSimilarQueryKey = (id: TelegramProductsControllerFindSimilarPathParams['id']) =>
  [{ url: '/api/telegram/products/similar/:id', params: { id: id } }] as const;

export type TelegramProductsFindSimilarQueryKey = ReturnType<typeof telegramProductsFindSimilarQueryKey>;

export function telegramProductsFindSimilarQueryOptions(
  id: TelegramProductsControllerFindSimilarPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramProductsFindSimilarQueryKey(id);
  return queryOptions<
    TelegramProductsControllerFindSimilarQueryResponse,
    ResponseErrorConfig<TelegramProductsControllerFindSimilar401>,
    TelegramProductsControllerFindSimilarQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramProductsFindSimilar(id, config);
    },
  });
}

/**
 * {@link /api/telegram/products/similar/:id}
 */
export function useTelegramProductsFindSimilar<
  TData = TelegramProductsControllerFindSimilarQueryResponse,
  TQueryData = TelegramProductsControllerFindSimilarQueryResponse,
  TQueryKey extends QueryKey = TelegramProductsFindSimilarQueryKey,
>(
  id: TelegramProductsControllerFindSimilarPathParams['id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramProductsControllerFindSimilarQueryResponse,
        ResponseErrorConfig<TelegramProductsControllerFindSimilar401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramProductsFindSimilarQueryKey(id);

  const query = useQuery(
    {
      ...telegramProductsFindSimilarQueryOptions(id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramProductsControllerFindSimilar401>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
